export default {"src":"/_next/static/media/BASE.789e7c5e.svg","height":60,"width":60,"blurWidth":0,"blurHeight":0};